
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./AppProviders": () => {
return Promise.all(/*  | __federation_expose_AppProviders */ [__webpack_require__.e("939"), __webpack_require__.e("152"), __webpack_require__.e("538")]).then(() => (() => (__webpack_require__(637))));
},
"./queryClient": () => {
return Promise.all(/*  | __federation_expose_queryClient */ [__webpack_require__.e("152"), __webpack_require__.e("157")]).then(() => (() => (__webpack_require__(850))));
},
"./account": () => {
return Promise.all(/*  | __federation_expose_account */ [__webpack_require__.e("152"), __webpack_require__.e("238")]).then(() => (() => (__webpack_require__(769))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };